import { AppState, dispatchAction } from "../TypesAndConstants/types";
import { initState } from "../TypesAndConstants/const";
import { createContext, useReducer } from "react";
import { Reducer } from "./Reducers/Reducer";
import React from "react";

export const Context = createContext<{
  state: AppState;
  dispatch: (action: dispatchAction) => void;
}>({
  state: initState,
  dispatch: () => {}
});

export const ContextConsumer = Context.Consumer;

export const ContextProvider = ({isPortrait, children }: any) => {
  const [state, dispatch] = useReducer(Reducer, initState);
  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  );
};
